import * as React from 'react';
import { useUserMessage_unstable } from './useUserMessage';
import { renderUserMessage_unstable } from './renderUserMessage';
import { useUserMessageStyles_unstable } from './useUserMessageStyles';
// UserMessage component - TODO: add more docs
export const UserMessage = /*#__PURE__*/React.forwardRef((props, ref) => {
  const state = useUserMessage_unstable(props, ref);
  useUserMessageStyles_unstable(state);
  return renderUserMessage_unstable(state);
});
UserMessage.displayName = 'UserMessage';
//# sourceMappingURL=UserMessage.js.map